import { apiFetch } from '../client';
import type { CatalogPermissionsResponse } from '../types/permissions';

export const catalogApi = {
    listPermissions: () => apiFetch<CatalogPermissionsResponse>('/catalog/permissions'),
    listCategories: () =>
        apiFetch<{ items: Array<{ key: string; displayName: string }> }>('/catalog/categories'),
};
